/* ============
 * Find specific transaction types.
 * ============
 *
 * Found transaction types.
 */

import Vue from 'vue';
import transactionTypeTransformer from './../../transformers/transactionType';

const success = ({ data }, resolve) => {
  const types = transactionTypeTransformer.fetchCollection(data.data);

  resolve(types);
};

const failed = () => {};

// Display transaction types.
export default transactionType => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`transaction_types/${transactionType}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/transactionType/find.js